function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSalesCommission = function SvgSalesCommission(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 83,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2404_715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.062 64.5611L32.0965 74.4209L0.730835 56.4728L0.929291 34.967L58.3314 0.842285L89.697 18.9889V41.6757L83.3852 45.2286",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0966 75.2582L0 56.889L0.203296 34.5555L0.556644 34.3473L58.3266 0L90.4231 18.5725V42.1016L83.7386 45.8578L83.027 44.5944L88.971 41.2497V19.4099L58.3363 1.68445L1.65057 35.3832L1.46179 56.0516L32.0917 73.5835L48.6942 63.9317L49.4251 65.1854L32.0966 75.2582Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6651 57.8522L32.4885 67.32L0.730774 49.3767",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4983 68.1574L0.372742 50.0108L1.08912 48.7474L32.4838 66.4826L48.2973 57.2229L49.0331 58.4766L32.4983 68.1574Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6651 50.7514L32.4885 60.2192L0.730774 42.2759",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4983 61.0565L0.372742 42.9099L1.08912 41.6466L32.4838 59.3818L48.2973 50.1221L49.0331 51.3758L32.4983 61.0565Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.730774 35.175L32.4885 53.1183L48.6651 43.6505L89.4404 19.0905",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4983 53.9557L0.372742 35.8042L1.08912 34.5409L32.4838 52.2809L48.2973 43.0212L89.0679 18.4708L89.8133 19.7148L49.0379 44.2701L32.4983 53.9557Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.312 26.2954L70.7941 37.1163L71.5267 38.3701L90.0446 27.5491L89.312 26.2954Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3018 33.1038L78.6703 39.4691L79.4163 40.715L90.0478 34.3497L89.3018 33.1038Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.945 36.1528C14.3419 36.1528 16.312 34.9669 14.3419 32.5999L56.5549 8.14148C56.5549 8.14148 58.1328 9.32737 60.1077 8.14148L75.4953 17.2172C75.4953 17.2172 74.3094 19.1921 75.4953 21.1621L34.4634 45.6254C34.4634 45.6254 31.3075 44.8364 30.1216 46.0223L13.945 36.1576V36.1528Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2329 46.9323L11.3603 35.4268H13.8773C13.9886 35.3784 14.3226 35.1799 14.4339 34.7975C14.6082 34.2263 14.1726 33.539 13.7805 33.0646L13.2287 32.4015L56.6082 7.27026L56.9906 7.55585C57.0341 7.58973 58.22 8.41743 59.7302 7.51228L60.0981 7.28963L76.4876 16.9559L76.1101 17.5851C76.0713 17.648 75.1759 19.2212 76.1101 20.7846L76.4828 21.409L34.5699 46.3951L34.2795 46.3224C33.3792 46.0998 31.2978 45.8529 30.6298 46.5257L30.2281 46.9275L30.2329 46.9323ZM15.31 36.1334L30.0829 45.1414C31.414 44.3524 33.5292 44.6816 34.3424 44.851L74.5515 20.8814C74.0093 19.5261 74.2949 18.2531 74.5708 17.5125L60.0981 8.97892C58.5395 9.73402 57.2181 9.30806 56.5646 8.98376L15.3972 32.8275C16.1232 34.0134 15.9877 34.9379 15.707 35.5332C15.6053 35.7559 15.4649 35.9544 15.3052 36.1286L15.31 36.1334Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9108 36.9418C33.5253 36.9418 35.6447 35.7044 35.6447 34.1779C35.6447 32.6515 33.5253 31.4141 30.9108 31.4141C28.2963 31.4141 26.1769 32.6515 26.1769 34.1779C26.1769 35.7044 28.2963 36.9418 30.9108 36.9418Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9107 37.6678C27.8468 37.6678 25.4508 36.1334 25.4508 34.1779C25.4508 32.2224 27.8516 30.688 30.9107 30.688C33.9698 30.688 36.3707 32.2224 36.3707 34.1779C36.3707 36.1334 33.9698 37.6678 30.9107 37.6678ZM30.9107 32.1449C28.5486 32.1449 26.9029 33.2195 26.9029 34.1827C26.9029 35.146 28.5486 36.2205 30.9107 36.2205C33.2728 36.2205 34.9186 35.146 34.9186 34.1827C34.9186 33.2195 33.2728 32.1449 30.9107 32.1449Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.319 19.9812C61.9335 19.9812 64.0529 18.7438 64.0529 17.2173C64.0529 15.6909 61.9335 14.4535 59.319 14.4535C56.7046 14.4535 54.5851 15.6909 54.5851 17.2173C54.5851 18.7438 56.7046 19.9812 59.319 19.9812Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.319 20.7024C56.255 20.7024 53.859 19.168 53.859 17.2124C53.859 15.2569 56.2598 13.7225 59.319 13.7225C62.3781 13.7225 64.7789 15.2569 64.7789 17.2124C64.7789 19.168 62.3781 20.7024 59.319 20.7024ZM59.319 15.1795C56.9569 15.1795 55.3111 16.2541 55.3111 17.2173C55.3111 18.1805 56.9569 19.2551 59.319 19.2551C61.6811 19.2551 63.3268 18.1805 63.3268 17.2173C63.3268 16.2541 61.6811 15.1795 59.319 15.1795Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3988 47.063V71.4633C53.3988 73.9707 59.2267 75.9988 66.4195 75.9988C73.6123 75.9988 79.4401 73.9658 79.4401 71.4633V47.3631L53.3988 47.063Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4196 76.7249C59.7544 76.7249 52.6729 74.8807 52.6729 71.4634V46.3273L80.1663 46.6467V71.4634C80.1663 74.8807 73.0848 76.7249 66.4196 76.7249ZM54.125 47.7939V71.4634C54.125 73.0559 58.8008 75.2727 66.4196 75.2727C74.0384 75.2727 78.7142 73.051 78.7142 71.4634V48.0795L54.125 47.7939Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4195 51.1434C73.6106 51.1434 79.4402 49.1128 79.4402 46.6079C79.4402 44.1031 73.6106 42.0725 66.4195 42.0725C59.2285 42.0725 53.3989 44.1031 53.3989 46.6079C53.3989 49.1128 59.2285 51.1434 66.4195 51.1434Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4197 51.8695C59.7545 51.8695 52.673 50.0254 52.673 46.6081C52.673 43.1907 59.7545 41.3466 66.4197 41.3466C73.0849 41.3466 80.1664 43.1907 80.1664 46.6081C80.1664 50.0254 73.0849 51.8695 66.4197 51.8695ZM66.4197 42.7938C58.8009 42.7938 54.1251 45.0156 54.1251 46.6032C54.1251 48.1909 58.8009 50.4126 66.4197 50.4126C74.0384 50.4126 78.7142 48.1909 78.7142 46.6032C78.7142 45.0156 74.0384 42.7938 66.4197 42.7938Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4401 54.8948C79.4401 57.4021 73.6123 59.4302 66.4195 59.4302C59.2267 59.4302 53.3988 57.3973 53.3988 54.8948",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4196 60.1563C59.7544 60.1563 52.6729 58.3121 52.6729 54.8948H54.125C54.125 56.4873 58.8008 58.7042 66.4196 58.7042C74.0384 58.7042 78.7142 56.4824 78.7142 54.8948H80.1663C80.1663 58.3121 73.0848 60.1563 66.4196 60.1563Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4401 63.1766C79.4401 65.684 73.6123 67.7121 66.4195 67.7121C59.2267 67.7121 53.3988 65.6791 53.3988 63.1766",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4197 68.4434C59.7545 68.4434 52.673 66.5992 52.673 63.1819H54.1251C54.1251 64.7744 58.8009 66.9913 66.4197 66.9913C74.0384 66.9913 78.7142 64.7695 78.7142 63.1819H80.1664C80.1664 66.5992 73.0849 68.4434 66.4197 68.4434Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2845 52.978V77.3784C76.2845 79.8857 82.1123 81.9138 89.3051 81.9138C96.4979 81.9138 102.326 79.8809 102.326 77.3784V53.2781L76.2845 52.978Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3002 82.6447C82.6349 82.6447 75.5535 80.8005 75.5535 77.3832V52.2471L103.047 52.5665V77.3832C103.047 80.8005 95.9654 82.6447 89.3002 82.6447ZM77.0056 53.7137V77.3832C77.0056 78.9756 81.6814 81.1925 89.3002 81.1925C96.9189 81.1925 101.595 78.9708 101.595 77.3832V53.9993L77.0056 53.7137Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3003 57.0632C96.4914 57.0632 102.321 55.0326 102.321 52.5277C102.321 50.0229 96.4914 47.9923 89.3003 47.9923C82.1092 47.9923 76.2797 50.0229 76.2797 52.5277C76.2797 55.0326 82.1092 57.0632 89.3003 57.0632Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3002 57.7893C82.6349 57.7893 75.5535 55.9452 75.5535 52.5278C75.5535 49.1105 82.6349 47.2664 89.3002 47.2664C95.9654 47.2664 103.047 49.1105 103.047 52.5278C103.047 55.9452 95.9654 57.7893 89.3002 57.7893ZM89.3002 48.7136C81.6814 48.7136 77.0056 50.9354 77.0056 52.523C77.0056 54.1107 81.6814 56.3324 89.3002 56.3324C96.9189 56.3324 101.595 54.1107 101.595 52.523C101.595 50.9354 96.9189 48.7136 89.3002 48.7136Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.321 60.8097C102.321 63.317 96.4931 65.3451 89.3003 65.3451C82.1075 65.3451 76.2797 63.3122 76.2797 60.8097",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3 66.0764C82.6348 66.0764 75.5533 64.2322 75.5533 60.8149H77.0055C77.0055 62.4074 81.6813 64.6243 89.3 64.6243C96.9188 64.6243 101.595 62.4026 101.595 60.8149H103.047C103.047 64.2322 95.9652 66.0764 89.3 66.0764Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.321 69.0964C102.321 71.6038 96.4931 73.6319 89.3003 73.6319C82.1075 73.6319 76.2797 71.5989 76.2797 69.0964",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3002 74.3579C82.6349 74.3579 75.5535 72.5137 75.5535 69.0964H77.0056C77.0056 70.6889 81.6814 72.9058 89.3002 72.9058C96.9189 72.9058 101.595 70.6841 101.595 69.0964H103.047C103.047 72.5137 95.9654 74.3579 89.3002 74.3579Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7867 31.4189L37.6195 12.8754L25.9784 20.165L57.741 38.1228L68.7867 31.4189Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7555 38.965L24.5602 20.1989L37.6098 12.0283L70.1953 31.414L57.7506 38.9699L57.7555 38.965ZM27.4015 20.1311L57.7313 37.2806L67.383 31.4189L37.634 13.7225L27.4015 20.1311Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1949 43.0649C96.6382 43.0649 96.0816 42.8519 95.6556 42.426C94.8037 41.5741 94.8037 40.1945 95.6556 39.3475L121.3 13.7031C122.152 12.8512 123.531 12.8512 124.378 13.7031C125.23 14.555 125.23 15.9346 124.378 16.7816L98.7341 42.426C98.3082 42.8519 97.7515 43.0649 97.1949 43.0649Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.696 42.271C121.529 42.271 123.827 39.9739 123.827 37.1402C123.827 34.3065 121.529 32.0094 118.696 32.0094C115.862 32.0094 113.565 34.3065 113.565 37.1402C113.565 39.9739 115.862 42.271 118.696 42.271Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.696 44.4444C114.668 44.4444 111.387 41.1674 111.387 37.1354C111.387 33.1034 114.664 29.8264 118.696 29.8264C122.728 29.8264 126.005 33.1034 126.005 37.1354C126.005 41.1674 122.728 44.4444 118.696 44.4444ZM118.696 34.1876C117.069 34.1876 115.743 35.5139 115.743 37.1402C115.743 38.7666 117.069 40.0929 118.696 40.0929C120.322 40.0929 121.648 38.7714 121.648 37.1402C121.648 35.509 120.327 34.1876 118.696 34.1876Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.929 24.318C104.762 24.318 107.06 22.0209 107.06 19.1872C107.06 16.3535 104.762 14.0564 101.929 14.0564C99.0951 14.0564 96.798 16.3535 96.798 19.1872C96.798 22.0209 99.0951 24.318 101.929 24.318Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.929 26.4962C97.9015 26.4962 94.6197 23.2193 94.6197 19.1873C94.6197 15.1552 97.8966 11.8783 101.929 11.8783C105.961 11.8783 109.238 15.1552 109.238 19.1873C109.238 23.2193 105.961 26.4962 101.929 26.4962ZM101.929 16.2395C100.302 16.2395 98.976 17.5609 98.976 19.1921C98.976 20.8233 100.297 22.1447 101.929 22.1447C103.56 22.1447 104.881 20.8185 104.881 19.1921C104.881 17.5657 103.56 16.2395 101.929 16.2395Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2404_715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 82.6447,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
};
export default SvgSalesCommission;